import styles from 'styles/ImagePlaceHolder.module.css'

type ImagePlaceHolderProps = {
  heading?: string;
  img: string;
}
function ImagePlaceHolder({ heading, img }: ImagePlaceHolderProps) {
  return (
    <div className={styles.container}>
      <div className={heading ? styles.heading : styles.hidden }>
        { heading}
      </div>
      <img
        src={img}
        alt='image'
        className={styles.image}
      />
    </div>
  )
}

export default ImagePlaceHolder
